<template>
    <div class="widget-view" :data-uuid="settings.uuid" :style="widgetStyle">
        <widget-wrapper :settings="settings">
            <component
                :settings="block"
                :is="resolveBlock(block)"
                :blocks-map="blocksMap"
                :elements-map="elementsMap"
                :key="index"
                v-for="(block, index) in children"
            ></component>
        </widget-wrapper>
    </div>
</template>

<script>
import WidgetBlockContainer from "./blocks/WidgetBlockContainer"
import WidgetCustomBlock from "./blocks/WidgetCustomBlock.vue"
import WidgetForm from "./blocks/WidgetForm.vue"
import WidgetButton from "./elements/WidgetButton.vue"
import WidgetLink from "./elements/WidgetLink.vue"
import WidgetImage from "./elements/WidgetImage.vue"
import WidgetText from "./elements/WidgetText.vue"
import WidgetField from "./elements/WidgetField.vue"
import WidgetStepBlock from "./blocks/WidgetStepBlock.vue"
import WidgetWrapper from "./WidgetWrapper.vue"
import WidgetRadioFormGroup from "./elements/WidgetRadioFormGroup.vue"
import WidgetHtmlBlock from "./blocks/WidgetHtmlBlock.vue"
import WidgetTimer from "@components/Builder/widget/elements/WidgetTimer.vue"

const blocksMap = {
    CUSTOM: WidgetCustomBlock,
    FORM: WidgetForm,
    STEP: WidgetStepBlock,
    HTML: WidgetHtmlBlock
}

const elementsMap = {
    BUTTON: WidgetButton,
    LINK: WidgetLink,
    IMAGE: WidgetImage,
    TEXT: WidgetText,
    FIELD: WidgetField,
    RADIO_FORM_GROUP: WidgetRadioFormGroup,
    TIMER: WidgetTimer
}

export default {
    components: { WidgetWrapper },
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetView",
    data() {
        return {
            blocksMap,
            elementsMap
        }
    },
    methods: {
        resolveBlock() {
            return WidgetBlockContainer
        }
    },
    computed: {
        children() {
            return this.settings.children.filter(
                child => !child.hasOwnProperty("hidden") || (child.hasOwnProperty("hidden") && !child.hidden)
            )
        },
        widgetStyle() {
            return {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                maxWidth: "100vw"
            }
        }
    }
}
</script>

